import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator as MatPaginatorNew } from '@angular/material/paginator';
import { GeneralItemDetailDialogComponent } from '../../../../shared-components/general-item-detail-dialog/general-item-detail-dialog.component';
import { Admin } from '../../../../model/admin';
import { UsersService } from '../../../../services/users.service';
import { CreateAdminDialogComponent } from '../create-admin-dialog/create-admin-dialog.component';

import { switchMap, tap } from 'rxjs/operators';
import { EMPTY, Observable, of } from 'rxjs';
import { DialogsService } from '../../../../services/dialogs.service';
import { SnackService } from '../../../../services/snack.service';
import { Sort } from "@angular/material/sort";
import { Constants } from "../../../../utils/constants";
import { AuthService } from "../../../../services/auth.service";
import { merge } from "lodash-es";

@Component({
  selector: 'aw-list-admins',
  templateUrl: './list-admins.component.html',
  styleUrls: ['./list-admins.component.scss']
})
export class ListAdminsComponent implements OnInit, AfterViewInit {

  public displayedColumns = [

    'firstName',
    'lastName',
    'email',
    'phone',
    'enabled',
    'action'
  ];
  disabled = false;
  disabledItemId: number[] = [];
  loading = false;
  enabled = true;
  @ViewChild('paginatorAdmins') paginatorUsers!: MatPaginatorNew;
  dataSource!: MatTableDataSource<Admin>;
  private allAdmins$!: Observable<Admin[]>;
  roles = Constants.roles;
  loggedUser: any;

  constructor(
    public dialog: MatDialog,
    private usersService: UsersService,
    private authService: AuthService,
    private dialogsService: DialogsService,
    private snackService: SnackService
  ) {
  }

  ngOnInit(): void {
    this.loggedUser = this.authService.loggedUser();
  }

  ngAfterViewInit(): void {
    this.allAdmins$ =
      of(true)
        .pipe(
          tap(() => this.loading = true),
          switchMap(() => this.usersService.getAllAdmins()),
          tap(x => {
            this.dataSource = new MatTableDataSource<Admin>(x);
            this.dataSource.paginator = this.paginatorUsers;
            this.loading = false;
          })
        );
    this.allAdmins$.subscribe();
  }

  applyFilters(event: string): void {
    this.dataSource.filter = event.trim().toLowerCase();
  }

  doSortUsers(event: Sort): void {
    this.dataSource.paginator?.firstPage();
    this.dataSource.data = this.dataSource.data.sort((a, b) => {

      const index: string = event.active;


      if (event.direction === 'asc') {
        return ('' + (b as any)[index]).localeCompare('' + (a as any)[index]);
      } else {
        return ('' + (a as any)[index]).localeCompare('' + (b as any)[index]);
      }

    }
    );
  }

  details(admin: Admin): void {
    this.dialog.open(GeneralItemDetailDialogComponent, { data: admin });
  }

  createUser(): void {
    this.disabled = true;
    this.dialog
      .open(CreateAdminDialogComponent, { data: new Admin() })
      .afterClosed()
      .pipe(switchMap(value => value ? this.allAdmins$ : EMPTY))
      .subscribe(
        () => {
          this.disabled = false;
        },
        (error) => {
          this.snackService.error(error.message);
          this.disabled = false;
        }, () => {
          this.disabled = false;
        });
  }

  editUser(admin: Admin): void {
    this.disabled = true;
    this.dialog
      .open(CreateAdminDialogComponent, { data: admin })
      .afterClosed()
      .pipe(switchMap(value => value ? this.allAdmins$ : EMPTY))
      .subscribe(
        () => {
          this.disabled = false;
        },
        (error) => {
          this.snackService.error(error.message);
          this.disabled = false;
        }, () => {
          this.disabled = false;
        });
  }

  deleteUser(admin: Admin): void {
    this.disabled = true;
    const id = admin.id ?? -1;
    this.disabledItemId.push(id);
    this.dialogsService
      .confirm('Delete administrator', `Are you sure you want to delete the administrator "${admin.firstName} ${admin.lastName}"?`)
      .pipe(
        switchMap((value) => value ?
          this.usersService.deleteAdmin(admin.id as number) :
          EMPTY),
        switchMap(() => this.allAdmins$)
      )
      .subscribe(() => {
        this.disabled = false;
        this.snackService.success('Administrator deleted!');
        this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
      }, (error) => {
        this.snackService.error(error.message);
        this.disabled = false;
        this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
      },
        () => {
          this.disabled = false;
          this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
        });

  }

  changeAdminHabilitation(admin: Admin): void {
    this.disabled = true;
    const editedAdmin = merge(new Admin(), admin);
    editedAdmin.enabled = !admin.enabled;
    const keyword = editedAdmin.enabled ? 'enable' : 'disable';
    this.dialogsService
      .confirm(`${keyword.toUpperCase()} administrator`, `Are you sure you want to ${keyword} the administrator "${admin.firstName} ${admin.lastName}"?`)
      .pipe(
        switchMap((value) => value ? this.usersService.updateAdmin(editedAdmin) : EMPTY),
        switchMap(() => this.allAdmins$)
      )
      .subscribe(() => {
        this.snackService.success(`Administrator ${keyword}d!`);
        this.disabled = false;
      },
        (error) => {
          this.snackService.error(error.message);
          this.disabled = false;
        },
        () => {
          this.disabled = false;
        });
  }
}
